import dayjs from 'dayjs';
import { mixed, object, ObjectSchema } from 'yup';

import { ResourceTimelineMessagesFormModel } from '@/components/timelineMessages/model/ResourceTimelineMessagesForm.model.ts';

export const useResourcesTimelineMessagesFormValidation =
  (): ObjectSchema<ResourceTimelineMessagesFormModel> => {
    return object().shape({
      createdFrom: mixed<dayjs.Dayjs>().optional(),
      createdTo: mixed<dayjs.Dayjs>().optional(),
    });
  };
